/**
 * 音声再生を管理するクラス
 */
export class AudioPlayer {
  private currentAudio: HTMLAudioElement | null = null;
  private currentPlaybackRate: number = 1.0;

  /**
   * 音声Blobを再生
   */
  async play(audioBlob: Blob): Promise<void> {
    return new Promise((resolve, reject) => {
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audio.playbackRate = this.currentPlaybackRate;
      this.currentAudio = audio;

      audio.onended = () => {
        URL.revokeObjectURL(audioUrl);
        this.currentAudio = null;
        resolve();
      };

      audio.onerror = (error) => {
        console.error('❌ 音声再生エラー:', error);
        URL.revokeObjectURL(audioUrl);
        this.currentAudio = null;
        reject(error);
      };

      audio.play().catch(reject);
    });
  }

  /**
   * 再生速度を設定（再生中でも即座に反映）
   */
  setPlaybackRate(rate: number): void {
    this.currentPlaybackRate = rate;
    if (this.currentAudio) {
      this.currentAudio.playbackRate = rate;
    }
  }

  /**
   * 現在の音声を停止
   */
  stop(): void {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
    }
  }

  /**
   * 現在再生中かどうか
   */
  get isPlaying(): boolean {
    return this.currentAudio !== null;
  }

  /**
   * プレイヤーを破棄
   */
  dispose(): void {
    this.stop();
  }
}
